import type { Node } from 'html2json';

export const createNode = (tag: string, child?: Node[], attr?: any): Node => ({
  ...(tag !== 'root' && { tag }),
  child,
  node: tag === 'text' ? 'text' : 'element',
  attr,
});
